import axios from 'axios';
import { Controller } from '@hotwired/stimulus';
import { csrfToken } from 'rails-ujs';
axios.defaults.headers.common['X-CSRF-Token'] = csrfToken();

export default class extends Controller {
  sendDeleteDocumentRequest(event, redirect_path = null) {
    const result = window.confirm('「' + event.params.title + '」を削除してよろしいですか？');
    if (result) {
      axios
        .delete(`/documents/${event.params.documentId}.json`)
        .then((response) => {
          if (response.status === 204) {
            if (redirect_path != null) return (location.href = redirect_path);
            location.reload();
          } else {
            alert('削除に失敗しました。再読込してください');
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }

  sendDeleteUserRequest(event, redirect_path = null) {
    const result = window.confirm(event.params.userName + 'を削除してよろしいですか？');
    if (result) {
      axios
        .delete(`/users/${event.params.userId}.json`)
        .then((response) => {
          if (response.status === 204) {
            if (redirect_path != null) return (location.href = redirect_path);
            location.reload();
          } else {
            alert('削除に失敗しました。再読込してください');
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }

  sendActivateUserRequest(event) {
    const result = window.confirm(event.params.confirmMessage);
    if (result) {
      axios
        .patch(`/users/${event.params.userId}/activate.json`)
        .then((response) => {
          if (response.status === 200) {
            location.reload();
          } else {
            alert('有効化に失敗しました。再読込してください');
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }

  sendDestroyWaitingUserRequest(event) {
    const result = window.confirm(event.params.confirmMessage);
    if (result) {
      axios
        .delete(`/users/${event.params.userId}/destroy_waiting.json`)
        .then((response) => {
          if (response.status === 204) {
            location.reload();
          } else {
            alert('削除に失敗しました。再読込してください');
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }

  sendToggleAdminRequest(event) {
    const isAdmin = event.params.isAdmin === 'true';
    const confirmMessage = isAdmin
      ? event.params.userName + ' の管理者権限を剥奪しますか？'
      : event.params.userName + ' に管理者権限を付与しますか？';
    const result = window.confirm(confirmMessage);
    if (result) {
      axios
        .patch(`/users/${event.params.userId}/toggle_admin.json`)
        .then((response) => {
          if (response.status === 200) {
            location.reload();
          } else {
            alert('更新に失敗しました。再読込してください');
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }
}
